import { api } from './api';

export interface DocValidationFinding {
  code: string;
  severity: 'hard_block' | 'warn' | 'info';
  message: string;
  field?: string;
  context?: Record<string, unknown>;
}

export interface DocValidationReport {
  decision: 'pass' | 'pass_with_warnings' | 'hard_block';
  totals: {
    documents_evaluated: number;
    hard_blocks: number;
    warnings: number;
    infos: number;
  };
  findings: DocValidationFinding[];
  per_document: Array<{
    filename: string;
    detected_type: string;
    findings: DocValidationFinding[];
  }>;
}

export interface DocValidationJob {
  id: string;
  status: 'queued' | 'processing' | 'awaiting_review' | 'completed' | 'failed' | 'cancelled';
  account_holder_name: string | null;
  source_filenames: string[];
  report: DocValidationReport | null;
  error_message: string | null;
  created_at: string;
  updated_at: string;
}

export const docsApi = {
  list: () => api.get<{ rows: DocValidationJob[] }>('/api/docs/jobs').then(r => r.data),
  get: (id: string) => api.get<DocValidationJob>(`/api/docs/jobs/${id}`).then(r => r.data),
  create: (args: { documents: File[]; account_holder_name?: string }) => {
    const form = new FormData();
    args.documents.forEach(f => form.append('documents', f));
    if (args.account_holder_name) form.append('account_holder_name', args.account_holder_name);
    return api.post<{ job_id: string; status: string }>('/api/docs/jobs', form).then(r => r.data);
  },
};
